import { CategorySettings } from '@wix/search-results-settings-definitions';
import { SearchDocumentType } from '@wix/client-search-sdk';

type CategoryEntry = [SearchDocumentType, CategorySettings];

export function sortCategories(
  visibleCategories: Array<[string, CategorySettings]>,
) {
  const sortedCategories = visibleCategories
    .sort((c1: CategoryEntry, c2: CategoryEntry) => c1[1].index - c2[1].index)
    .map(c => c[0]);
  return sortedCategories;
}
